import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastPayload {
  title: string;
  message: string;
  durationMs?: number;
  fadeMs?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toast$ = new BehaviorSubject<ToastPayload | null>(null);
  readonly toast$ = this._toast$.asObservable();

  show(payload: ToastPayload): void {
    this._toast$.next({
      durationMs: 1200,
      fadeMs: 300,
      ...payload
    });
  }

  clear(): void {
    this._toast$.next(null);
  }
}
